import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentReAssignDto extends EpimsBaseEntityDto {
    
    EventTypeId: string;
    ReAssignId: string;
    ReAssignName: string;  
    ReAssignAt: Date; 
    ReAssignById: string; 
    ReAssignByName: string; 
    ReAssignReasons: string; 
    
    IncidentTrackingNo: string;
    

}